import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Tab,
  CircularProgress,
} from "@mui/material";
import QuestionListModal from "./QuestionListModal";
import Loader from "./loader/Loader";
import { TabContext, TabList, TabPanel } from "@mui/lab";

const ExamArenaTopSection = () => {
  const [tabValue, setTabValue] = useState("subjective");
  const [subjectiveQuestions, setSubjectiveQuestions] = useState([]);
  const [tncQuestions, setTncQuestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedQuestions, setSelectedQuestions] = useState(null);
  const [showOptions, setShowOptions] = useState(null);
  const [showOptionsTnc, setShowOptionsTnc] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [file, setFile] = useState({});
  const [addPaperLoader, setAddPaperLoader] = useState(false);
  const [replacePaperLoader, setReplacePaperLoader] = useState(false);
  const [deletePaperLoader, setDeletePaperLoader] = useState(false);

  const getdetails = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        // `http://localhost:8600/api/tutorWeb/get-questions`,
        // `https://drifting-console-1.el.r.appspot.com/api/tutorWeb/get-questions`,
        `https://testapis4.el.r.appspot.com/api/tutorWeb/get-questions`,
        {
          params: {
            type: tabValue,
          },
        }
      );

      if (response.status === 201 || response.status === 200) {
        if (tabValue === "subjective") {
          setSubjectiveQuestions(response.data.files);
        } else {
          setTncQuestions(response.data.files);
        }
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      alert("Some error occured in retrieving files. Please try again.");
    }
  }, [tabValue]);

  useEffect(() => {
    getdetails();
  }, [tabValue, getdetails]);

  const handleQuestionClick = (questionContent, index, tab) => {
    if (tab === "subjective") {
      setSelectedQuestions(questionContent);
      setShowOptions(index);
    } else {
      setSelectedQuestions(questionContent);
      setShowOptionsTnc(index);
    }
  };

  const handleFileChange = async (event, index, type, tncFileName) => {
    try {
      const newFiles = event.target.files;
      if (!newFiles.length) {
        console.error("No files selected");
        return;
      }
      const file = newFiles[0];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (fileExtension === "docx") {
        console.log("File accepted:", file);
      } else {
        alert("Please upload a .docx file.");
        return;
      }
      setReplacePaperLoader(true);
      const reader = new FileReader();
      reader.onload = async () => {
        const base64Data = reader.result;
        setFile({
          name: selectedSubject.split("/").slice(2, 3)[0],
          mimeType: file.type,
          buffer: base64Data,
        });
        const selFilename =
          type === "tnc"
            ? tncFileName.split("/").slice(2, 3)[0]
            : selectedSubject.split("/").slice(2, 3)[0];
        try {
          const response = await axios.post(
            // `http://localhost:8600/api/tutorWeb/replace-file`,
            // `https://drifting-console-1.el.r.appspot.com/api/tutorWeb/replace-file`,
            `https://testapis4.el.r.appspot.com/api/tutorWeb/replace-file`,
            {
              file: {
                name: selFilename,
                mimeType: file.type,
                base64Data: base64Data,
              },
              type: type,
            }
          );
          setReplacePaperLoader(false);
          if (response.status === 200 || response.status === 201) {
            alert("File uploaded successfully");
            await getdetails();
            setShowOptions(null);
          }
        } catch (error) {
          setReplacePaperLoader(false);
          console.error("Error uploading file:", error);
          alert("Some error occured. Please try again.");
        }
      };

      reader.onerror = (error) => {
        console.error("Error reading file:", error);
      };

      reader.readAsDataURL(file);
    } catch (err) {
      setReplacePaperLoader(false);
      alert("Some error occured. Please try again.");
    }
  };

  const removeFileExtension = (filename) => {
    return filename.replace(/\.[^/.]+$/, "");
  };

  const getSubjectName = (filename) => {
    const nameParts = filename.split("/");
    return removeFileExtension(nameParts[nameParts.length - 1]);
  };

  const switchTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleChangeDropdown = (e) => {
    setSelectedSubject(e.target.value);
    setShowOptions(null);
  };

  console.log("selected TENC", tncQuestions);

  const deleteSubject = async (type, tncFileName) => {
    try {
      setDeletePaperLoader(true);
      let selFilename =
        type === "tnc"
          ? tncFileName.split("/").slice(2, 3)[0]
          : selectedSubject.split("/").slice(2, 3)[0];
      const response = await axios.post(
        // `http://localhost:8600/api/tutorWeb/delete-file`,
        // `https://drifting-console-1.el.r.appspot.com/api/tutorWeb/replace-file`,
        `https://testapis4.el.r.appspot.com/api/tutorWeb/delete-file`,
        {
          file: {
            name: selFilename,
          },
          type,
        }
      );
      setDeletePaperLoader(false);
      if (response.status === 200 || response.status === 201) {
        console.log("File deleted successfully");
        alert("File deleted successfully");

        await getdetails();
        setShowOptions(null);
      }
    } catch (err) {
      setDeletePaperLoader(false);
      await getdetails();
      // alert("Some error occured. Please try again.");
      console.error("Error while deleting file", err);
    }
  };

  const addPaper = async (event, type) => {
    try {
      const newFiles = event.target.files;
      if (!newFiles.length) {
        console.error("No files selected");
        return;
      }
      const file = newFiles[0];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (fileExtension === "docx") {
        console.log("File accepted:", file);
      } else {
        alert("Please upload a .docx file.");
        return;
      }
      setAddPaperLoader(true);
      const reader = new FileReader();
      reader.onload = async () => {
        const base64Data = reader.result;
        try {
          const response = await axios.post(
            // `http://localhost:8600/api/tutorWeb/replace-file`,
            // `https://drifting-console-1.el.r.appspot.com/api/tutorWeb/replace-file`,
            `https://testapis4.el.r.appspot.com/api/tutorWeb/replace-file`,
            {
              file: {
                name: file.name,
                mimeType: file.type,
                base64Data: base64Data,
              },
              type,
            }
          );
          setAddPaperLoader(false);
          if (response.status === 200 || response.status === 201) {
            alert("File uploaded successfully");
            await getdetails();
            setShowOptions(null);
          }
        } catch (error) {
          setAddPaperLoader(false);
          console.error("Error uploading file:", error);
          alert("Some error occured. Please try later");
          // throw new Error("Error occured while uploading file.");
        }
      };

      reader.onerror = (error) => {
        console.error("Error reading file:", error);
      };

      reader.readAsDataURL(file);
    } catch (err) {
      console.error(err);
      setAddPaperLoader(false);
      alert("Some error occured. Please try later");
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "white",
        padding: "10px 5px",
      }}
    >
      <Card sx={{ maxWidth: "100%" }}>
        <CardHeader title="View Exam Questions And Answers" />
        <Divider />
        <CardContent>
          <Box>
            <TabContext value={tabValue}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList onChange={switchTab} aria-label="Exam Tabs">
                  <Tab label="Subjective" value="subjective" />
                  <Tab label="Terms & Condition" value="tnc" />
                </TabList>
              </Box>

              <TabPanel value="subjective">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Paper</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedSubject}
                    label="Set"
                    onChange={handleChangeDropdown}
                  >
                    {subjectiveQuestions &&
                      !!subjectiveQuestions.length > 0 &&
                      subjectiveQuestions.map((value, index) => (
                        <MenuItem key={index} value={value.name}>
                          {getSubjectName(value.name)}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>

                <Button
                  variant="contained"
                  component="label"
                  sx={{ ml: "70%", mt: "10px" }}
                >
                  Add Paper
                  {addPaperLoader && (
                    <CircularProgress
                      style={{
                        width: "22px",
                        height: "22px",
                        marginLeft: "5px",
                      }}
                      color="inherit"
                    />
                  )}
                  <input
                    type="file"
                    accept=".docx"
                    hidden
                    onChange={(event) => addPaper(event, "subjective")}
                  />
                </Button>

                <Box mt={4}>
                  {isLoading && (
                    <div className="flex items-center justify-center h-28">
                      <Loader />
                    </div>
                  )}
                  {subjectiveQuestions.length > 0 && (
                    <Box>
                      {subjectiveQuestions
                        ?.filter((el) => el.name === selectedSubject)
                        ?.map((question, index) => (
                          <Box key={index} sx={{ marginBottom: "10px" }}>
                            {selectedSubject && (
                              <Button
                                onClick={() =>
                                  handleQuestionClick(
                                    question.content,
                                    index,
                                    "subjective"
                                  )
                                }
                                variant="outlined"
                                sx={{ display: "block", marginBottom: "5px" }}
                              >
                                {getSubjectName(selectedSubject)}
                              </Button>
                            )}
                            {showOptions === index && (
                              <Box sx={{ display: "flex", gap: "10px" }}>
                                <Button
                                  onClick={() => setOpen(true)}
                                  variant="contained"
                                >
                                  View
                                </Button>
                                <Button variant="contained" component="label">
                                  Change
                                  {replacePaperLoader && (
                                    <CircularProgress
                                      style={{
                                        width: "22px",
                                        height: "22px",
                                        marginLeft: "5px",
                                      }}
                                      color="inherit"
                                    />
                                  )}
                                  <input
                                    type="file"
                                    hidden
                                    onChange={(event) =>
                                      handleFileChange(
                                        event,
                                        index,
                                        "subjective",
                                        selectedSubject
                                      )
                                    }
                                    // onChange={(event) =>
                                    //   handleFileChange(event, index)
                                    // }
                                  />
                                </Button>
                                <Button
                                  variant="contained"
                                  onClick={() =>
                                    deleteSubject("subjective", selectedSubject)
                                  }
                                >
                                  Remove
                                  {deletePaperLoader && (
                                    <CircularProgress
                                      style={{
                                        width: "22px",
                                        height: "22px",
                                        marginLeft: "5px",
                                      }}
                                      color="inherit"
                                    />
                                  )}
                                </Button>
                              </Box>
                            )}
                          </Box>
                        ))}
                    </Box>
                  )}
                </Box>
              </TabPanel>
              <TabPanel value="tnc">
                <Box>
                  {isLoading && (
                    <div className="flex items-center justify-center h-28">
                      <Loader />
                    </div>
                  )}
                  {/* <Button
                    variant="contained"
                    component="label"
                    sx={{ ml: "70%", mt: "10px" }}
                  >
                    
                    Add Paper
                     {addPaperLoader && (
                    <CircularProgress
                      style={{
                        width: "22px",
                        height: "22px",
                        marginLeft: "5px",
                      }}
                      color="inherit"
                    />
                  )}
                    <input
                      type="file"
                      accept=".docx"
                      hidden
                      onChange={(event) => addPaper(event, "tnc")}
                    />
                  </Button> */}
                  {tncQuestions.length > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "15px",
                      }}
                    >
                      {tncQuestions.map((question, index) => (
                        <Box key={index} sx={{ marginBottom: "10px" }}>
                          <Stack flexDirection="row">
                            <Button
                              onClick={() =>
                                handleQuestionClick(
                                  question.content,
                                  index,
                                  "tnc"
                                )
                              }
                              variant="outlined"
                              sx={{ display: "block", marginBottom: "5px" }}
                            >
                              {question.name.split("/").slice(2, 3)}
                            </Button>
                          </Stack>
                          {showOptionsTnc === index && (
                            <Box sx={{ display: "flex", gap: "10px" }}>
                              <Button
                                onClick={() => setOpen(true)}
                                variant="contained"
                              >
                                View
                              </Button>
                              <Button variant="contained" component="label">
                                Change
                                {replacePaperLoader && (
                                  <CircularProgress
                                    style={{
                                      width: "22px",
                                      height: "22px",
                                      marginLeft: "5px",
                                    }}
                                    color="inherit"
                                  />
                                )}
                                <input
                                  type="file"
                                  hidden
                                  onChange={(event) =>
                                    handleFileChange(
                                      event,
                                      index,
                                      "tnc",
                                      question.name
                                    )
                                  }
                                />
                              </Button>
                              {/* <Button
                                variant="contained"
                                onClick={() =>
                                  deleteSubject("tnc", question.name)
                                }
                              >
                      Remove
                                  {deletePaperLoader && (
                                    <CircularProgress
                                      style={{
                                        width: "22px",
                                        height: "22px",
                                        marginLeft: "5px",
                                      }}
                                      color="inherit"
                                    />
                                  )}
                              </Button> */}
                            </Box>
                          )}
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              </TabPanel>
            </TabContext>
          </Box>
        </CardContent>
        <CardContent>
          {open && (
            <QuestionListModal
              open={open}
              selectedQuestions={selectedQuestions}
              handleClose={() => setOpen(false)}
            />
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default ExamArenaTopSection;
